import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.282 19.778 2.631 22.43a.75.75 0 0 1-1.06-1.06l2.65-2.652 1.061 1.06Z",
  "clip-rule": "evenodd"
}, null, -1), d = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M14.121 12.707 11.293 9.88l-7.778 7.778a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l7.778-7.778Zm-3.712 1.945a.75.75 0 1 0-1.06-1.061l-2.83 2.828a.75.75 0 0 0 1.062 1.061l2.828-2.828Z",
  "clip-rule": "evenodd"
}, null, -1), c = /* @__PURE__ */ e("path", { d: "m17.657 3.515 2.828 2.828L14.828 12 12 9.172l5.657-5.657Zm2.121-2.122a1 1 0 0 1 1.414 0l1.415 1.415a1 1 0 0 1 0 1.414l-1.415 1.414-2.828-2.828 1.414-1.415Z" }, null, -1), r = [
  n,
  d,
  c
];
function s(a, i) {
  return l(), t("svg", o, [...r]);
}
const p = { render: s };
export {
  p as default,
  s as render
};
